<template>
  <li class="side-menu-list__item">
    <a href="#" class="side-menu-list__icon" :class="icon" v-on:click.prevent="toggle"></a>
    <div class="sidebar" v-if="active">
      <div class="sidebar__block">
        <p class="sidebar__title">{{getResource('LoggedAs')}}:</p>
        <p class="sidebar__value">{{loggedUser.FullName}}</p>
        <p class="sidebar__value">{{loggedUser.Company}}</p>
      </div>
      <div class="sidebar__block">
        <p class="sidebar__title">{{getResource('InterfaceLanguage')}}</p>
        <select class="select select--fullwidth" v-model="culture" @change="getResources(culture, true)">
          <option :value="language.Culture" v-for="language in languages">{{language.Name}}</option>
        </select>
      </div>
      <div class="sidebar__block"  v-if="impersonationVisible !== ''">
        <p class="sidebar__title">{{getResource('Impersonation')}}</p>
        <input class="input input--user_search" placeholder="{{getResource('SearchUser')}}" v-model="searchString"/>
        <button class="button button--user_search" @click="search()" :disabled="searchString.length < 3">{{getResource('Search')}}</button> 
      </div>
      <div class="sidebar__block">
        <button class="button" @click="logout">{{getResource('Logout')}}</button> 
      </div>
    </div>
    <div v-if="active" class="side-menu-closer" v-on:click.prevent="toggle">
    </div>
  </li>
</template>
<script>
  import { searchImpersonation } from "../../../views/impersonation/ImpersonationActions";
  import { getResource } from "../../../vuex/helpers";
  import { getResources, logout } from "../../../AppActions";

  export default {
    data: function () {
      return {
        searchString: "",
        culture: window.localStorage.getItem("current_culture")
      };
    },
    vuex: {
      getters: {
        scroll: state => state.scrolled,
        menuItem: state => state.menuItem,
        languages: state => state.menu.Language,
        isModalVisible: state => state.impersonateModalVisibility,
        loggedUser: state => state.menu.LoggedUser,
        sidebarActive: state => state.sidebarActive,
        impersonationVisible: state => state.menu.ImpersonationVisible
      },
      actions: {
        getResource, getResources, searchImpersonation, logout
      }
    },
    computed: {
      active () {
        return this.menuItem === this._uid;
      },
      icon () {
        var icon = (this.$route.path === "/" && !this.scroll) ? "icon-user-white" : "icon-user";
        icon += (this.sidebarActive && !this.active) ? " icon--disabled" : "";
        return icon;
      }
    },
    methods: {
      toggle () {
        this.$dispatch("submenu_clicked", this._uid, true);
      },
      search () {
        this.toggle();
        this.searchImpersonation(this.searchString);
      }
    }
  };
</script>
<style lang="scss">
  @import '../../../assets/scss/variables.scss';
  @import '../../../assets/scss/mixins.scss';

  .input.input--user_search {
    width:56%;
    border: 1px solid grey;
    border-top-right-radius:0em;
    border-bottom-right-radius:0em;
    vertical-align: top;
  }
  .button--user_search {
    border-top-left-radius:0em;
    border-bottom-left-radius:0em;
    width: 44%;
    margin-left: -9px;
  }
</style>



// WEBPACK FOOTER //
// SidebarPerson.vue?591ff18e